import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getNewsInner } from "../Service/Api";

function News() {
  const [newsData, setNewsData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [search, setSearch] = useState("");

  const BASE_URL = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const data = await getNewsInner();

        const formatted = data.map((item) => {
          const date = new Date(item.fromDate);

          return {
            ...item,
            year: date.getFullYear().toString(),
            month: (date.getMonth() + 1).toString(),
            dateText: date.toLocaleDateString("en-GB"),
          };
        });

        setNewsData(formatted);

        const uniqueYears = [
          ...new Set(formatted.map((item) => item.year)),
        ].sort((a, b) => b - a);

        if (uniqueYears.length > 0) {
          setSelectedYear(uniqueYears[0]);
        }
      } catch (error) {
        console.error("News API Error:", error);
      }
    };

    fetchNews();
  }, []);

  const uniqueYears = useMemo(() => {
    return [...new Set(newsData.map((item) => item.year))].sort(
      (a, b) => b - a,
    );
  }, [newsData]);

  const filteredNews = useMemo(() => {
    return newsData.filter((item) => {
      const yearMatch = selectedYear === "All" || item.year === selectedYear;

      const monthMatch =
        selectedMonth === "All" || item.month === selectedMonth;

      const searchMatch =
        item.title?.toLowerCase().includes(search.toLowerCase()) ||
        item.description?.toLowerCase().includes(search.toLowerCase());

      return yearMatch && monthMatch && searchMatch;
    });
  }, [newsData, selectedYear, selectedMonth, search]);

  return (
    <>
      {/* Header */}
      <Header />

      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="News"
          title2=""
          parentTitle="Home"
          path="News"
        />
      </div>

      <div className="innerbody">
        <div className="container-fluid">
          <div className="row tabs-dynamics mt-3">
            <div className="col-lg-3 col-md-6 col-12">
              <div className="filter-card count-card mb-2">
                <p>
                  Total Count <span>{filteredNews.length}</span>
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12">
              <div className="filter-card h-100">
                <select
                  className="form-select filter-select"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  <option value="All">All Years</option>

                  {uniqueYears.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12">
              <div className="filter-card h-100">
                <select
                  className="form-select filter-select"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option value="All">All Months</option>

                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={(i + 1).toString()}>
                      {new Date(0, i).toLocaleString("en-US", {
                        month: "short",
                      })}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12">
              <div className="filter-card h-100">
                <input
                  type="text"
                  className="form-control filter-input"
                  placeholder="Search News..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row mt-4">
            {filteredNews.length > 0 ? (
              filteredNews.map((item) => (
                <div key={item._id} className="col-12 mb-4">
                  <div className="news-card">
                    <span className="news-date">{item.dateText}</span>

                    <div className="news-body">
                      <h3>{item.title}</h3>

                      <p>{item.description}</p>

                      {item.attachments?.length > 0 && (
                        <a
                          href={`${BASE_URL}${item.attachments[0]}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="attachment"
                        >
                          <i className="bi bi-paperclip"></i>
                          View Attachment
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXCKWB/public/images/dummy.jpg"
                  alt="No News"
                  className="img-fluid"
                />
                <h5 className="mt-3">No News Found</h5>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default News;
